import { func, shape, string } from "prop-types";
import React, { useEffect, useState } from "react";

//Hooks
import { useSignIn } from "@overrides_venia/peregrine/talons/SignIn/useSignIn";

//Style
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import UIkit from "uikit";
import defaultClasses from "./signIn.module.scss";
import loadingPasta from "@Assets/images/loading_pasta.gif";
import signInIndicatorClasses from "../LoadingIndicator/signInIndicator.module.scss";

//Utils
import { useSignInEvent } from "@Components/SocialLogin/talons/useSignInEvent";
import { useIntl } from "react-intl";
import { isRequired } from "../../util/formValidators";

//Components
import { Form } from "informed";
import { useHistory } from "react-router-dom";
import Icon from "../../../../components/Icon";
import Button from "../Button";
import FormError from "../FormError";
import Password from "../Password";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";

// Utils
import { resetWeglot } from "@overrides_venia/venia-ui/components/WeglotInit/weglotInit";
import { useCartContext } from "@overrides_venia/peregrine/context/cart";
import LoadingIndicator from "../LoadingIndicator";
import { isEmailValid, isPasswordValid } from "@Src_main/utils/generalUtils";
import { useCustomerCart } from "@overrides_venia/peregrine/talons/SignIn/useCustomerCart";
import { SimpleField } from "@Components/FormFields/SimpleField";
var SignIn = _ref => {
  var {
    showCreateAccount,
    showForgotPassword,
    disablePreLogin,
    classes: propsClasses
  } = _ref;
  var classes = mergeClasses(defaultClasses, propsClasses);
  var {
    isBusy: isBusySL
  } = useSignInEvent();
  useCustomerCart();
  var {
    isMobile
  } = useWindowSize();
  var [loginButtonDisable, setLoginButtonDisable] = useState(true);
  var [erroreLogin, setErroreLogin] = useState(false);
  var [isEmailOk, setIsEmailOk] = useState(false);
  var [{
    cartId,
    details
  }] = useCartContext();
  var {
    formatMessage
  } = useIntl();
  var talonProps = useSignIn({
    showCreateAccount,
    showForgotPassword
  });
  var {
    errors,
    handleSubmit,
    isBusy,
    setFormApi
  } = talonProps;
  var history = useHistory();
  useEffect(() => {
    var errori = Array.from(errors.values());
    errori.map((item, i) => errori[i] ? errori[i].message.includes("sign-in was incorrect or your account is disabled temporarily.") ? setErroreLogin(true) : null : null);
  }, [errors]);
  var isCheckoutPage = location.pathname.includes(formatMessage({
    id: "url.key.checkout"
  }));
  var isCartEmpty = !cartId || !details || !details.total_quantity;
  if (isBusy || isBusySL || isCheckoutPage && isCartEmpty) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.modal_active
    }, /*#__PURE__*/React.createElement(LoadingIndicator, {
      width: 200,
      heigth: 200,
      message: " ",
      global: true,
      src: loadingPasta,
      classes: {
        global: signInIndicatorClasses.global
      }
    }, formatMessage({
      id: "utils.loading"
    })));
  }
  var handleChange = event => {
    var emailValid = event.values.email && isEmailValid(event.values.email);
    var passwordValid = event.values.password;
    if (emailValid) setIsEmailOk(true);else setIsEmailOk(false);
    if (emailValid && passwordValid) {
      setLoginButtonDisable(false);
    } else {
      setLoginButtonDisable(true);
    }
  };
  var errorPass = /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-text-center ".concat(classes.infobox)
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-close",
    color: "white"
  }), formatMessage({
    id: "signin.error.password"
  }));
  function goToRegistration() {
    try {
      if (window.location.pathname.includes(formatMessage({
        id: "url.key.signup"
      }))) {
        UIkit.offcanvas("#offcanvas-login-dx").hide();
      } else {
        UIkit.offcanvas("#offcanvas-registration-dx").show();
      }
    } catch (error) {
      console.error(error);
    }
  }
  var registrationButton = isMobile && !disablePreLogin ? /*#__PURE__*/React.createElement("div", {
    className: "button-container_login"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "headerSignInMobile",
    color: "dark-green",
    fullScreen: true,
    type: "button",
    onClick: () => {
      resetWeglot();
      goToRegistration();
    }
  }, formatMessage({
    id: "button.registration"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "button-container_login"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "headerSignInDesktop",
    color: "dark-green",
    fullScreen: true,
    type: "button",
    onClick: () => {
      resetWeglot();
      goToRegistration();
    }
  }, formatMessage({
    id: "button.registration"
  })));
  var registrationBox = /*#__PURE__*/React.createElement("div", {
    className: "uk-container uk-padding-small-top"
  }, /*#__PURE__*/React.createElement("p", {
    className: "uk-text-center title-registration"
  }, formatMessage({
    id: "signin.label.no.account"
  })), registrationButton);
  return /*#__PURE__*/React.createElement("div", {
    className: "page_wrapper"
  }, /*#__PURE__*/React.createElement(FormError, {
    errors: Array.from(errors.values())
  }), /*#__PURE__*/React.createElement(Form, {
    getApi: setFormApi,
    className: "uk-flex uk-flex-column ".concat(classes.form),
    onSubmit: handleSubmit,
    onChange: handleChange,
    autoComplete: "off"
  }, /*#__PURE__*/React.createElement(SimpleField, {
    name: "email",
    label: "email",
    type: "email",
    id: "emailLogin",
    required: true,
    invalid: !isEmailOk
  }), /*#__PURE__*/React.createElement(Password, {
    fieldName: "password",
    label: "password",
    validate: isRequired,
    autoComplete: "current-password",
    isToggleButtonHidden: false,
    errorPass: erroreLogin ? true : false,
    id: "passwordLogin",
    required: true
  }), erroreLogin && errorPass, /*#__PURE__*/React.createElement("div", {
    className: "uk-text-center uk-margin-small-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "recoverypwd",
    onClick: () => {
      try {
        UIkit.offcanvas("#offcanvas-login-dx").hide();
        UIkit.offcanvas("#offcanvas-pwdforgot-dx").show();
      } catch (error) {
        console.error(error);
      }
    }
  }, formatMessage({
    id: "signin.label.forgot.password"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "button-container_login"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "loginButton",
    color: "primary",
    fullScreen: true,
    type: "submit",
    disabled: loginButtonDisable
  }, formatMessage({
    id: "button.login"
  })))), !isBusy && registrationBox);
};
export default SignIn;
SignIn.propTypes = {
  classes: shape({
    buttonsContainer: string,
    form: string,
    forgotPasswordButton: string,
    forgotPasswordButtonContainer: string,
    root: string,
    title: string
  }),
  setDefaultUsername: func,
  showCreateAccount: func,
  showForgotPassword: func
};
SignIn.defaultProps = {
  setDefaultUsername: () => {},
  showCreateAccount: () => {},
  showForgotPassword: () => {}
};